import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/22.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Rozmawiasz z Hornem"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Dalej",
        }}
        links={{
            link1: PAGES.p38,
        }}
        content={
            <div>
                <ul>
                    <li>Jesteście rybakami? – pytasz Horna.</li>
                    <li>Tak, bo co?</li>
                    <li>Ryby bierzemy tylko od rybaków, sprawdzona marka! – śmieje się nerwowo Emil. – On gości we wsi od niedawna, to nie wie…</li>
                </ul>
                <p>
                Horn patrzy na Ciebie surowo, ale odpowiada:
                </p>
                <ul>
                    <li>Moja rodzina jest tu od stuleci. Myślisz: rybak, to pewnie tylko ryby łowi. Błąd. To chirurgiczna robota. W głowie mamy mapy, znamy tę ziemię. Mnie to ojciec opowiedział i pokazał, a jemu jego ojciec. Trzeba wiedzieć, gdzie zalewa, gdzie nie. Gdzie zalewa, strzyżesz trawę, żeby woda była czysta. Moja żona zna wszystkie oczka wodne i tam swoje robi. Na Babidole pierze, na Moczydle moczy len, na Ciżemku naciąga… Są jeszcze Kapelusz, Lipówka, Płociczne Moczydło, Kukowy… – tutaj Horn urywa, jakby zawstydził się, że tak się rozgadał przed nieznajomą osobą. – Macie ryby, zdrowia życzę! – odwraca się na pięcie, podchodzi do żony i obejmuje ją ramieniem.</li>
                </ul>
            </div>
        }
        />
        
            );
}